import { CommonModule } from '@angular/common'
import { Component, DestroyRef } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import {
  ActivatedRouteSnapshot,
  NavigationEnd,
  Router,
  RouterLink,
} from '@angular/router'
import { TranslatePipe } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'
import { startWith } from 'rxjs'
import { filter } from 'rxjs/operators'

import { RouteData } from '../../app.routes'

export interface BreadcrumbItem {
  label: string
  route?: string | string[]
}

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterLink, SvgIconComponent, TranslatePipe],
  templateUrl: './breadcrumb.component.html',
})
export class BreadcrumbComponent {
  public items: BreadcrumbItem[] = []

  public constructor(
    private readonly router: Router,
    private readonly destroyRef: DestroyRef
  ) {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
        startWith(true) // trigger initial render
      )
      .subscribe(() => {
        this.items = []
        this.addBreadcrumb(this.router.routerState.snapshot.root, [])
      })
  }

  private addBreadcrumb(
    route: ActivatedRouteSnapshot,
    parentUrl: string[]
  ): void {
    // Construct the route URL
    const routeUrl = parentUrl.concat(route.url.map((url) => url.path))
    const data = route.data as RouteData

    if (data.breadcrumbI18nKey) {
      const breadcrumb = {
        label: data.breadcrumbI18nKey,
        route: '/' + routeUrl.join('/'),
      }
      this.items.push(breadcrumb)
    }

    // Add another element for the next route part
    if (route.firstChild !== null)
      this.addBreadcrumb(route.firstChild, routeUrl)
  }
}
